import(/* webpackMode: "eager" */ "/home/u539503415/domains/centronics.com.sa/public_html/.builds/source/techsolutions_pro/src/app/about/page.tsx");
